import { Component, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { ThemeOptions } from '../../../../../../theme-options';
import { KeycloakService } from 'keycloak-angular';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'app/Shared/Services/user.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { EndOfDayService } from "../../../../../../Shared/Services/end-of-day.service";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReservationService } from 'app/Shared/Services/reservation.service';

@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
  styleUrls: ['./user-box.component.css']
})
export class UserBoxComponent implements OnInit {
  ListPriveredgroup: any[] = [];
  groupId: any;
  name: any;
  Date: any;
  colors: boolean = false;
  private groupIdSubject = new BehaviorSubject<number>(null);
  groupId$ = this.groupIdSubject.asObservable();
  private myPOSSubject = new BehaviorSubject<any>(null);
  myPOS$: Observable<any> = this.myPOSSubject.asObservable();
  @ViewChild(NgbDropdown) myDropdown: NgbDropdown;
  showPreferredHotels = false;
  showPreferredServices: boolean = false;
  ListPriveredService: any[] = [];
  MyPOS: any = undefined;
  k:any = 0;
  nameHotel:any = undefined;
  speedMessage: string = 'Checking speed...';
  circleClass: string = 'circle';
  interval: any;
  constructor(public globals: ThemeOptions,
              private keyCloakService: KeycloakService,
              private userService: UserService,
              private endOfDay: EndOfDayService,
              private router: Router,
              private reservationService:ReservationService,
              private translate: TranslateService) {
    this.refreshMyPOS();
  }

  isNavbarCollapsed = true;
  index: number = 0;
  indexBack: number | null = null;
  TypeEvent: any[] = [
    { auditEventTypeId: 6, name: 'CheckOut', nameEn: 'CheckOut' },
    { auditEventTypeId: 7, name: 'LogIn', nameEn: 'LogIn' },
    { auditEventTypeId: 8, name: 'LogOut', nameEn: 'LogOut' },
    { auditEventTypeId: 9, name: 'Create Reservation', nameEn: 'Create Reservation' },
    { auditEventTypeId: 10, name: 'Update Reservation', nameEn: 'Update Reservation' },
    { auditEventTypeId: 11, name: 'Routing', nameEn: 'Routing' },
    { auditEventTypeId: 12, name: 'Room assignmen', nameEn: 'Room assignmen' },
    { auditEventTypeId: 13, name: 'Room Move', nameEn: 'Room Move' },
    { auditEventTypeId: 14, name: 'Edit Price', nameEn: 'Edit Price' },
    { auditEventTypeId: 15, name: 'Fee', nameEn: 'Fee' },
    { auditEventTypeId: 16, name: 'PreCheckin', nameEn: 'PreCheckin' },
    { auditEventTypeId: 17, name: 'Cancelled', nameEn: 'Cancelled' },
    { auditEventTypeId: 18, name: 'No Show', nameEn: 'No Show' },
    { auditEventTypeId: 18, name: 'Apply taxes', nameEn: 'Apply taxes' },
    { auditEventTypeId: 4, name: 'Edit Customer', nameEn: 'Edit Customer' },
    { auditEventTypeId: 22, name: 'Add Extras', nameEn: 'Add Extra' },
    { auditEventTypeId: 19, name: 'Add Folio', nameEn: 'Add Folio' },
    { auditEventTypeId: 20, name: 'Attach files', nameEn: 'Attach files' },
    { auditEventTypeId: 21, name: 'Create Note', nameEn: 'Create Note' },
    { auditEventTypeId: 22, name: 'Room Closed', nameEn: 'Room Closed' },
    { auditEventTypeId: 23, name: 'Room Cleaned', nameEn: 'Room Cleaned' },
    { auditEventTypeId: 24, name: 'Room Dirty', nameEn: 'Room Dirty' },
    { auditEventTypeId: 25, name: 'Detached Room', nameEn: 'Detached Room' },
    { auditEventTypeId: 26, name: 'Create Room', nameEn: 'Create Room' },
    { auditEventTypeId: 27, name: 'Add Payment', nameEn: 'Add Payment' },
    { auditEventTypeId: 28, name: 'Edit Payment', nameEn: 'Edit Payment' },
    { auditEventTypeId: 29, name: 'Delete Payment', nameEn: 'Delete Payment' },
    { auditEventTypeId: 30, name: 'NFC-RFID Activated', nameEn: 'NFC-RFID Activated' },
    { auditEventTypeId: 31, name: 'NFC-RFID Disabled', nameEn: 'NFC-RFID Disabled' },
    { auditEventTypeId: 32, name: 'Room Edited', nameEn: 'Room Edited' },
    { auditEventTypeId: 33, name: 'Daily Closing', nameEn: 'Daily Closing' },
    { auditEventTypeId: 34, name: 'Create User', nameEn: 'Create User' },
    { auditEventTypeId: 35, name: 'Edit user', nameEn: 'Edit user' },
    { auditEventTypeId: 36, name: 'Remove User', nameEn: 'Remove User' },
    { auditEventTypeId: 37, name: 'Add Support', nameEn: 'Add Support' },
    { auditEventTypeId: 5, name: 'Checkin', nameEn: 'Checkin' },
    { auditEventTypeId: 1, name: 'Delogement', nameEn: 'Dislodging' },
    { auditEventTypeId: 38, name: 'Cancel Checkin', nameEn: 'Cancel Checkin' }
  ];
  EventNew : any = {
    user:null,
    groupId:0,
    type:null,
    message:null,
    priority:"Critical",
    itemId:null,
    detail:null,
    itemNumber:null,


}
  logCurrentIndexAndItems() {
    console.log("Current index:", this.index, "Current items:");
  }

  langue = 'fr';
  ngOnInit() {
    // Start checking the speed when the component is initialized
    this.checkSpeed();
    // Set an interval to refresh the speed every 2 minutes (120000 ms)
    this.interval = setInterval(() => {
      this.checkSpeed();
    }, 10000);

    this.langue = localStorage.getItem('sitelang') || 'fr';
    this.translate.setDefaultLang(this.langue);
    this.translate.use(this.langue);
    this.loadUserDetails();
    this.logCurrentIndexAndItems();
  }

  refreshMyPOS() {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (userDetails && userDetails.pos) {
      this.myPOSSubject.next(userDetails.pos);
    } else {
      this.myPOSSubject.next(null);
    }
  }


//   async NewGroup(i: number) {
//     let userOld = JSON.parse(localStorage.getItem("userDetails"));
//     let user = JSON.parse(localStorage.getItem("userDetails"));
//     user.group = this.ListPriveredgroup[i]; 
    
//     await this.userService.updateUser(user).toPromise();
    
//     this.keyCloakService
//       .getKeycloakInstance()
//       ?.loadUserInfo()
//       .then((res: any) => {
//         this.userService.getUserByCode<any>(res.sub).subscribe(async (data: any) => {
          
//           localStorage.setItem('userDetails', JSON.stringify(data));
//           console.log("User after update and get code:", data);
          
//           this.refreshMyPOS();  // Refresh POS details after updating user details
//           // Navigate and reload the current tab
//           await this.router.navigate(['/main/dashboardAdmin']);
//           window.location.reload();
//           // ✅ Broadcast the group switch event with an origin ID to avoid closing the current tab
//              localStorage.setItem('closeOtherTabs', JSON.stringify({
//               timestamp: new Date().getTime(),
//               groupId: userOld.group.groupId, // ✅ Use the new group ID
//               origin: window.location.href  // ✅ Unique identifier for the current tab
//           }));

//         });
//       });
// }


// async NewGroup(i: number) {
//   // ✅ Affichage immédiat : écran temporaire avec spinner
//   document.body.innerHTML = `
//     <div style="
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       justify-content: center;
//       height: 100vh;
//       background-color: #ffffff;
//       font-size: 18px;
//       color: #333;
//       text-align: center;
//     ">
//       <div style="
//         width: 50px;
//         height: 50px;
//         border: 6px solid #ccc;
//         border-top-color: #007bff;
//         border-radius: 50%;
//         animation: spin 1s linear infinite;
//       "></div>
//       <p style="margin-top: 20px;">
//         🔄 Changement de groupe en cours...<br>
//         <span style="font-size: 14px; color: #666;">Veuillez patienter</span>
//       </p>
//     </div>
//     <style>
//       @keyframes spin {
//         to { transform: rotate(360deg); }
//       }
//     </style>
//   `;

//   // ✅ Mise à jour du groupe sélectionné
//   const user = JSON.parse(localStorage.getItem("userDetails") || '{}');
//   user.group = this.ListPriveredgroup[i];

//   await this.userService.updateUser(user).toPromise();

//   const keycloak = this.keyCloakService.getKeycloakInstance();
//   if (keycloak) {
//     keycloak.loadUserInfo().then((res: any) => {
//       this.userService.getUserByCode<any>(res.sub).subscribe((data: any) => {
//         localStorage.setItem('userDetails', JSON.stringify(data));
//         this.refreshMyPOS();

//         const currentTabId = sessionStorage.getItem('tabId');
//         console.log("✅ currentTabId in switch", currentTabId);

//         if (currentTabId) {
//           const channel = new BroadcastChannel('tab-control');
//           channel.postMessage({ activeTabId: currentTabId });
//           channel.close();
//         }

//         // ✅ Attendre un peu avant redirection
//         setTimeout(async () => {
//           await this.router.navigate(['/main/dashboardAdmin']).then(() => {
//             window.location.reload();
//           });
//         }, 300);
//       });
//     });
//   }
// }



async NewGroup(i: number) {
  // 1. ✅ Affichage du Loader (votre code actuel est très bien pour bloquer l'UI)
  this.showFullPageLoader(); 

  try {
    // 2. Récupération de l'utilisateur actuel
    const user = JSON.parse(localStorage.getItem("userDetails") || '{}');
    
    // 3. ✅ LOGIQUE SCREEN 3 : Mise à jour du groupe
    // On récupère le nouveau groupe depuis votre liste de privilèges
    const nextGroup = this.ListPriveredgroup[i];
    
    if (!nextGroup) return;

    // Mise à jour de la structure de l'utilisateur
    user.group = nextGroup;
    // Optionnel : si votre API attend un champ spécifique 'groupId' à la racine
    user.groupId = nextGroup.groupId; 

    console.log("🔄 Tentative de switch vers le groupe :", nextGroup.name);

    // 4. Envoi de la mise à jour au serveur
    await this.userService.updateUser(user).toPromise();

    // 5. Rafraîchissement des données Keycloak et Session
    const keycloak = this.keyCloakService.getKeycloakInstance();
    if (keycloak) {
      const res: any = await keycloak.loadUserInfo();
      
      // On récupère la version "fraîche" de l'utilisateur depuis la DB
      this.userService.getUserByCode<any>(res.sub).subscribe((data: any) => {
        
        // ✅ On écrase l'ancien userDetails avec le nouveau groupId
        localStorage.setItem('userDetails', JSON.stringify(data));
        
        this.refreshMyPOS();

        // Gestion du Broadcast pour les onglets
        const currentTabId = sessionStorage.getItem('tabId');
        if (currentTabId) {
          const channel = new BroadcastChannel('tab-control');
          channel.postMessage({ activeTabId: currentTabId });
          channel.close();
        }

        // 6. ✅ Redirection et Reload pour réinitialiser tous les services Angular
        setTimeout(() => {
          this.router.navigate(['/main/dashboardAdmin']).then(() => {
            window.location.reload(); // Indispensable pour recharger les permissions/intercepteurs
          });
        }, 500);
      });
    }
  } catch (error) {
    console.error("❌ Erreur lors du switch de groupe :", error);
    window.location.reload(); // On reload pour sortir du spinner en cas d'erreur
  }
}

// Extraction du loader pour plus de propreté
private showFullPageLoader() {
  document.body.innerHTML = `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; background-color: #ffffff;">
      <div class="spinner"></div>
      <p style="margin-top: 20px; font-family: sans-serif;">🔄 Synchronisation du profil en cours...</p>
    </div>
    <style>
      .spinner { width: 50px; height: 50px; border: 6px solid #ccc; border-top-color: #3f51b5; border-radius: 50%; animation: spin 1s linear infinite; }
      @keyframes spin { to { transform: rotate(360deg); } }
    </style>`;
}









  NewService(i: number) {
    let user = JSON.parse(localStorage.getItem("userDetails"));
    user.pos = this.ListPriveredService[i];
    this.userService.updateUser(user).toPromise();
    this.keyCloakService
      .getKeycloakInstance()
      ?.loadUserInfo()
      .then((res: any) => {
        this.userService.getUserByCode<any>(res.sub).subscribe(async (data: any) => {
          localStorage.setItem('userDetails', JSON.stringify(data));
          console.log("user after update and get code ", data);
          this.refreshMyPOS();  // Refresh POS details after updating user details
          await this.router.navigate(['/main/dashboardAdmin']);
          window.location.reload();
        });
      });
  }

  toggleDropdown(type: string, event: Event) {
    event.stopPropagation();
    if (type === 'hotel') {
      this.showPreferredHotels = !this.showPreferredHotels;
      this.showPreferredServices = false;
    } else if (type === 'service') {
      this.showPreferredServices = !this.showPreferredServices;
      this.showPreferredHotels = false;
    }
  }

  onDropdownContentClick(event: Event) {
    event.stopPropagation();
  }

  async logout() {
    console.log(this.keyCloakService.keycloakEvents$);
    await this.PutEveznt("Logged out of RoomEase",this.TypeEvent[2]);
    await localStorage.removeItem("userDetails");
    console.log("in logout JSON.parse(localStorage.getItem('userDetails'))", JSON.parse(localStorage.getItem("userDetails")));
    this.keyCloakService.logout();
       

  }

  loadUserDetails() {
    // Add a check to verify if user details are available in localStorage
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    if (!userDetails) {
      if(this.k == 5){
        this.keyCloakService.logout();
      }
        // If userDetails is not available, log the issue or handle it
        console.log("User details not available in localStorage. Reloading...");
        setTimeout(() => {
            this.loadUserDetails();
            this.k++ // Try loading user details again after a delay
        }, 20000);
        return;
    }

    // If user details are present, continue with normal logic
    this.ListPriveredgroup = (userDetails.preferredGroups || []).filter((group: any) => group.groupId !== 0);
    this.ListPriveredService = userDetails.preferredPos;
    this.MyPOS = userDetails.pos;
    this.name = userDetails.name;

    // Ensure groupId is properly set
    this.groupId = userDetails.group ? userDetails.group.groupId : null;
    this.nameHotel = userDetails.group ? userDetails.group.name : null;

    console.log("User details loaded successfully:", userDetails);
        this.userService.getDateClosed().subscribe(
      (response: string) => {
        this.endOfDay.setHetelDay(response);
        this.Date = response;

        let MyDateClosed = this.Date.split('-');
        let year = parseInt(MyDateClosed[0], 10);
        let month = parseInt(MyDateClosed[1], 10);
        let day = parseInt(MyDateClosed[2], 10);

        let Today = new Date();
        let currentYear = Today.getFullYear();
        let currentMonth = Today.getMonth() + 1;
        let currentDay = Today.getDate();

        if (year === currentYear && month === currentMonth && day === currentDay) {
          this.colors = true;
          console.log("i am here now AA ", this.colors);
        } else {
          this.colors = false;
          console.log("i am here now DD", this.colors);
        }
      },
      (error) => {
        console.error('Error fetching date closed:', error);
      }
    );
    this.refreshMyPOS();

    // Other initialization logic here...
}
  onSelectLangue($event: any){
    const selectedLang = $event.target.value;
    localStorage.setItem('sitelang', selectedLang);
    this.translate.use(selectedLang);
  }

    // Method to check the internet speed
    checkSpeed() {
      const startTime = new Date().getTime();
      const image = new Image();
  
      image.onload = () => {
        const endTime = new Date().getTime();
        const duration = (endTime - startTime) / 1000; // Duration in seconds
        const fileSize = 1000 * 8; // Example size (in kilobits)
        const speed = (fileSize / duration) / 1024; // Speed in Mbps
  
        this.updateCircleAndMessage(speed);
      };
  
      image.onerror = () => {
        // Connection refused or unreachable — update UI to show poor/unknown state
        this.circleClass = 'circle red';
        this.speedMessage = 'Speed: Unknown (No connection)';
      };
      image.src = 'https://your-server.com/small-file.jpg' + '?rand=' + Math.random(); // Randomize to avoid cache
    }
  
    // Method to update the circle color and message based on speed
    updateCircleAndMessage(speed: number) {
      if (speed > 20) {
        this.circleClass = 'circle green';
        this.speedMessage = `Speed: ${speed.toFixed(2)} Mbps (Good)`;
      } else if (speed > 10 && speed <= 20) {
        this.circleClass = 'circle orange';
        this.speedMessage = `Speed: ${speed.toFixed(2)} Mbps (Moderate)`;
      } else {
        this.circleClass = 'circle red';
        this.speedMessage = `Speed: ${speed.toFixed(2)} Mbps (Poor)`;
      }
    }

    ngOnDestroy() {
      // Clear the interval when the component is destroyed
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    async PutEveznt(message:any,type:any){
      this.EventNew.user = JSON.parse(localStorage.getItem("userDetails"));
      this.EventNew.message = message;
      this.EventNew.type = type,
  
      //put event test 
      await this.reservationService.puteventNote(this.EventNew).toPromise();
  }
  
}
